import styled from 'styled-components';
import { space, SpaceProps } from 'styled-system';

export const Wrapper = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.gray.light};
  padding-top: ${({ theme }) => theme.space[5]}px;
`;

export const List = styled.ul<SpaceProps>`
  ${space};
  font-size: ${({ theme }) => theme.fontSizes[1]}px;
  font-family: ${({ theme }) => theme.fonts.secondary};

  padding-left: ${({ theme }) => theme.space[6]}px;
`;
